import {Notifier} from '@airbrake/browser';

class Airbrake {
    public init(): Notifier {
        const n = new Notifier({
            projectId: 175680,
            projectKey: 'd6b03ac5401742063a1fe26c3d3e6cff',
            environment: this.environment(),
        });

        n.addFilter((notice) => notice.context.environment ? notice : null);

        return n;
    }

    private environment(): string | null {
        switch (process.env.BILLER_ENV) {
            case 'prod':
                return 'production';
            case 'stag':
                return 'staging';
            default:
                return null;
        }
    }
}

export default new Airbrake().init();
